import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { GraduationCap, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl bg-white/5 border border-white/15 focus:border-gold focus:ring-2 focus:ring-gold/20 px-4 py-3.5 text-white placeholder:text-white/40 outline-none transition-all";

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-gold text-sm mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
        <div className="text-center mb-8">
          <span className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-gold text-navy mx-auto mb-4">
            <GraduationCap className="w-8 h-8" />
          </span>
          <h1 className="font-display text-2xl font-bold text-white">Admin Portal</h1>
          <p className="text-white/50 text-sm mt-1">Invicta Overseas — Enquiry Management</p>
        </div>

        <form onSubmit={submit} data-testid="login-form" className="bg-white/5 border border-white/10 rounded-3xl p-8 space-y-4">
          <div>
            <label className="text-sm font-semibold text-white/80 mb-1.5 block">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@invictaoverseas.com" className={inputCls} />
          </div>
          <div>
            <label className="text-sm font-semibold text-white/80 mb-1.5 block">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400 font-medium">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-gold hover:bg-gold-dark text-white py-3.5 font-bold flex items-center justify-center gap-2 disabled:opacity-60 transition-all active:scale-[0.99]">
            {loading && <Loader2 className="w-5 h-5 animate-spin" />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
